import type { CurrentRefinementsConnectorParamsItem } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

import { useMemo } from 'react';
import { useCurrentRefinements } from 'react-instantsearch';

import { useProductListContext } from '~/utilities/context/static/ProductListContext';
import type { SelectedFacetV2 } from '~/utilities/graphql/codegen';

type AppliedSOLRFacets = SelectedFacetV2[];

type AppliedFacets = {
  appliedSOLRFacets: AppliedSOLRFacets;
  exclusiveAlgoliaFacets: CurrentRefinementsConnectorParamsItem[];
  numberOfAppliedFacets: number;
};

const EMPTY_APPLIED_SOLR_FACETS: AppliedSOLRFacets = [];

export const useAppliedFacets = (): AppliedFacets => {
  const { items: appliedAlgoliaFacets } = useCurrentRefinements();
  const { categoryDetails } = useProductListContext();
  const appliedSOLRFacets = useMemo(
    () => categoryDetails?.selectedFacetsV2?.filter((facet): facet is SelectedFacetV2 => !!facet),
    [categoryDetails?.selectedFacetsV2]
  );
  const normalizedAppliedSOLRFacets = appliedSOLRFacets ?? EMPTY_APPLIED_SOLR_FACETS;

  const exclusiveAlgoliaFacets = useMemo(
    () =>
      appliedAlgoliaFacets.filter(
        facet =>
          !normalizedAppliedSOLRFacets.some(solrFacet =>
            solrFacet.code?.includes(facet.attribute.split('.').at(0) ?? '')
          )
      ),
    [appliedAlgoliaFacets, normalizedAppliedSOLRFacets]
  );

  return {
    appliedSOLRFacets: normalizedAppliedSOLRFacets,
    exclusiveAlgoliaFacets,
    numberOfAppliedFacets: exclusiveAlgoliaFacets.length + normalizedAppliedSOLRFacets.length,
  };
};
